import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import { v4 as uuidv4 } from "uuid";
import {
  getPurchaseInvoiceBranch,
  getPurchaseInvoiceBranchById,
  getParticularPage,
  getPurchaseOrderDetail,
  getNext,
  getPrevious,
  handleSearch,
  createPurchaseInvoiceBranch,
} from "./thunk";
import { NepaliDate } from "@zener/nepali-datepicker-react";
import { dateFormater } from "../../../../../../Utils/dateFormater";
import { materialRequestsFrom } from "../../../../../../Utils/constants";

const initialState = {
  purchaseInvoiceBranchs: [],
  edit: false,
  purchaseInvoiceBranch: null,
  count: 0,
  pageNo: 1,
  next: null,
  previous: null,
  loading: false,
  loadingCreate: false,
  loadingUpdated: false,
  loadingPurchaseInvoiceBranch: false,
  loadingNext: false,
  loadingDetails: false,

  purchaseInvoiceBranchDetails: [],
  additionalCharges: null,
  showCreateModal: false,

  formData: {
    purchaseOrderMain: null,
    invoiceNo: null,
    branch: null,
    refNo: null,
    voucherDateBs: new NepaliDate(),
    narration: "",
    discountAmount: "",
    grandTotal: "",
    vatAmount: "",
    documentsAttach: [],
  },
};

export const purchaseInvoiceBranchSlice = createSlice({
  name: "purchaseInvoiceBranch",
  initialState,
  reducers: {
    setShowCreateModal: (state, action) => {
      state.showCreateModal = action.payload;
    },
    goToPage: (state, { payload }) => {
      state.pageNo = payload;
    },
    updatedAdditionalCharges: (state, action) => {
      state.additionalCharges = action.payload;
    },
    purchaseInvoiceBranchDetailsUpdated: (state, action) => {
      state.purchaseInvoiceBranchDetails = action.payload;
    },
    clearPurchaseInvoiceBranchDetails: (state, action) => {
      state.purchaseInvoiceBranchDetails = [];
    },

    clearPurchaseInvoiceBranchDetails: (state) => {
      state.purchaseInvoiceBranchDetails = [];
    },
    clearAllPurchaseInvoiceBranch: (state) => {
      state.edit = false;
      state.loading = false;
      state.loadingUpdated = false;
      state.loadingPurchaseInvoiceBranch = false;
      state.purchaseInvoiceBranch = null;
      state.purchaseInvoiceBranchDetails = [];
      state.formData = initialState.formData;
    },

    savePurchaseInvoiceBranchForm: (state, action) => {
      state.formData = action.payload;
    },
  },
  extraReducers: (builder) => {
    // get
    builder.addCase(createPurchaseInvoiceBranch.pending, (state) => {
      state.loadingCreate = true;
    });
    builder.addCase(createPurchaseInvoiceBranch.fulfilled, (state, action) => {
      state.loadingCreate = false;
    });
    builder.addCase(createPurchaseInvoiceBranch.rejected, (state) => {
      state.loadingCreate = false;
    });
    builder.addCase(getPurchaseOrderDetail.pending, (state) => {
      state.loadingDetails = true;
      state.purchaseInvoiceBranch = null;
      state.purchaseInvoiceBranchDetails = null;
    });
    builder.addCase(getPurchaseOrderDetail.fulfilled, (state, action) => {
      state.loadingDetails = false;
      state.purchaseInvoiceBranch = action.payload.data;
      state.purchaseInvoiceBranchDetails = action.payload.data?.goodReceiptNotesDetails;
    });
    builder.addCase(getPurchaseOrderDetail.rejected, (state) => {
      state.loadingDetails = false;
      state.purchaseInvoiceBranch = null;
      state.purchaseInvoiceBranchDetails = null;
    });
    // getPurchaseInvoiceBranchById
    builder.addCase(getPurchaseInvoiceBranchById.pending, (state) => {
      state.loading = true;
      state.purchaseInvoiceBranch = null;
    });
    builder.addCase(getPurchaseInvoiceBranchById.fulfilled, (state, action) => {
      const data = action.payload.data;
      const salesInvoiceMain = data?.salesInvoiceMain;
      const purchaseInvoiceBranch = data?.purchaseInvoiceBranch;

      const mapWithUniqueId = (items = []) => items.map((item) => ({ ...item, unique: uuidv4() }));

      state.edit = true;
      state.loading = false;
      state.purchaseInvoiceBranch = data;
      state.purchaseInvoiceBranchDetails = mapWithUniqueId(salesInvoiceMain?.saleInvoiceDetails);

      state.additionalCharges = mapWithUniqueId(data?.salesInvoiceMainAdditionalChargeCost);
      state.formData = {
        ...data,
        purchaseOrderMain: salesInvoiceMain?.purchaseOrderMain || null,
        invoiceNo: salesInvoiceMain?.invoiceNo || "",
        voucherDateBs: new NepaliDate(),
        branch: data?.branch || null,
        refNo: salesInvoiceMain?.refNo || "",
      };
    });
    builder.addCase(getPurchaseInvoiceBranchById.rejected, (state) => {
      state.edit = false;
      state.loading = false;
      state.purchaseInvoiceBranch = null;
    });
    builder.addMatcher(
      isAnyOf(
        getPurchaseInvoiceBranch.pending,
        getParticularPage.pending,
        getPrevious.pending,
        getNext.pending,
        handleSearch.pending
      ),
      (state) => {
        state.loadingPurchaseInvoiceBranch = true;
      }
    );

    builder.addMatcher(
      isAnyOf(
        getPurchaseInvoiceBranch.fulfilled,
        getParticularPage.fulfilled,
        getPrevious.fulfilled,
        getNext.fulfilled,
        handleSearch.fulfilled
      ),
      (state, action) => {
        state.loadingPurchaseInvoiceBranch = false;
        state.purchaseInvoiceBranchs = action.payload.data;
        state.count = action.payload.totalCount;

        state.previous = action.payload.previous;
        state.next = action.payload.next;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getPurchaseInvoiceBranch.rejected,
        getParticularPage.rejected,
        getPrevious.rejected,
        getNext.rejected,
        handleSearch.rejected
      ),
      (state) => {
        state.loadingPurchaseInvoiceBranch = false;
      }
    );
  },
});

export const {
  setShowCreateModal,
  goToPage,
  updatedAdditionalCharges,
  savePurchaseInvoiceBranchForm,
  purchaseInvoiceBranchDetailsUpdated,
  clearPurchaseInvoiceBranchDetails,
  clearAllPurchaseInvoiceBranch,
  resetPurchaseInvoiceBranchForm,
} = purchaseInvoiceBranchSlice.actions;

export default purchaseInvoiceBranchSlice.reducer;
